module.exports = __webpack_public_path__ + "img/2024-18.5eb6c074.jpg";